import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {FaTrash,FaPlus,FaEdit} from "react-icons/fa";
import { collection, getDocs, getDoc, doc, onSnapshot, setDoc, getFirestore, deleteDoc, addDoc } from "firebase/firestore";
import swal from "sweetalert";


export default function Admin(props) {
    const db = getFirestore()
    let navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [selectedUser,setSelectedUser]=useState("");
    const [selectedUserData,setSelectedUserData]=useState("");


    useEffect(async () => {
        if (localStorage.getItem("admin") == "true") {

            var snap = await onSnapshot(collection(db, "admin"),(docs)=>{
                var tempUsers = [];
            
                docs.forEach((doca) => {
                    var data = doca.data();
                    tempUsers.push(
                        {
                            "email": doca.id,
                            "password": data["password"],
                            "pages": data["pages"]
                        }
                    );
                    console.log(tempUsers);
                    console.log('fetched');
            });
            setUsers([...tempUsers]);

            
            });

            var unsub=onSnapshot(doc(db,"admin",selectedUser),(snap2)=>{
                setSelectedUserData(snap2.data());
            });

        }
        else {
            navigate("/welcome");
        }

        return function(){
            unsub();
        }

    }, [selectedUser]);






    return (
        <div className=" h-screen w-full flex justify-start items-center">

            <div className="w-2/4 h-full bg-black/80 flex justify-center items-center">

                <div className="text-4xl w-full h-full font-bold p-4">
                   
                   
                    <div className="p-3 mb-8 flex flex-row gap-5 justify-center text-white items-center">
                        All Users
                        
                        <button
                        onClick={()=>{
                            var newEmail="";
                            var newPass="";

                            swal("Kindly Enter User Email", {
                                content: "input",
                            }).then(async(email) => {
                                swal("Kindly Enter User Password", {
                                    content: "input",
                                }).then(async(pass) => {

                                        setSelectedUser("");
                                        await setDoc(doc(db,"admin",email.trim().toString()),{"password":pass,"email":email,"pages":{}});
                                });   
                            });

                        }}
                        className="bg-red-500 p-2 flex justify-center items-center text-white rounded-md">
                            <FaPlus size={20}/>
                        </button>

                    </div>



                    <div className="bg-white/20 h-4/5 w-full overflow-scroll p-4 pt-5 flex flex-col gap-4 justify-start rounded-md items-start">
                        {
                            users.map((user) => {
                                return (
                                    <div key={user["email"]} className="flex flex-row justify-center items-center gap-2">
                                        <button
                                        onClick={async() => {
                                            
                                            var snap3= await getDoc(doc(db,"admin",user["email"]));
                                            setSelectedUserData(snap3.data());

                                            setSelectedUser(user["email"]);
                                            
                                         }}
                                        className="hover:scale-105 text-xl bg-white pl-3 pr-3 pt-2 pb-2 rounded-3xl font-normal text-black">
                                        {user["email"].toString()}
                                        </button>

                                        <button onClick={async()=>{
                                            setSelectedUser("");
                                            await deleteDoc(doc(db,"admin",user["email"]));

                                        }} className="hover:scale-105 text-xl bg-white text-red-500 font-bold p-2 rounded-md">
                                            <FaTrash/>
                                        </button>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </div>






            {
                selectedUser!=""?<div className="p-20 w-2/4 h-screen bg-yellow-400 flex flex-col gap-4 justify-center items-center overflow-scroll">


                

                <div className="flex flex-row w-full justify-start gap-1 items-center text-bold text-3xl text-black">
                    
                    <div className="text-3xl font-bold">
                        Email:
                    </div>
                    
                    <div className="text-2xl font-bold">
                        {
                            selectedUserData!=undefined?selectedUserData["email"]:""
                        }
                    </div>
                    

                </div>



                <div className="flex flex-row w-full justify-start gap-4 items-center text-bold text-3xl text-black mb-8">
                    
                    <div className="text-3xl font-bold">
                        Password:
                    </div>
                    
                    <div className="text-2xl font-bold">
                        {
                            selectedUserData!=undefined?selectedUserData["password"]:""
                        }
                    </div>
                    
                    
                    <button
                    className="hover:scale-105 ml-4"
                    onClick={()=>{
                        swal("Kindly Enter New Password", {
                            content: "input",
                        }).then(async(pass) => {

                                setSelectedUser("");
                                await setDoc(doc(db,"admin",selectedUserData["email"].trim().toString()),{"password":pass},{merge:true});
                        }); 
                    }}>
                        <FaEdit/>    
                    </button>

                </div>

                <div className="flex flex-row w-full justify-start gap-4 items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Dashboard
                    </div>
                    
                    <button
                    onClick={async()=>{
                        var newPages=selectedUserData["pages"];
                        newPages["dashboard"]=!newPages["dashboard"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["dashboard"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>

                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Users
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["users"]=!newPages["users"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["users"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>


                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Celebrities
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["celebs"]=!newPages["celebs"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["celebs"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>




                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Settings
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["settings"]=!newPages["settings"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["settings"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>



                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Reports
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["reports"]=!newPages["reports"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["reports"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>





                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Payments
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["payments"]=!newPages["payments"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["payments"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>




                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Withdrawls
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["withdrawls"]=!newPages["withdrawls"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["withdrawls"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>





                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Requests
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["requests"]=!newPages["requests"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["requests"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>




                <div className="flex flex-row w-full justify-start gap-4  items-center text-bold text-3xl text-black">
                    <div className="text-3xl font-bold">
                        Promos
                    </div>
                    
                    <button
                    onClick={async()=>{

                        var newPages=selectedUserData["pages"];
                        newPages["promos"]=!newPages["promos"];
                        await setDoc(doc(db,"admin",selectedUser),{"pages":newPages},{merge:true});

                    }} className="hover:scale-105 shadow-xl bg-white pl-5 pr-5 pt-2 pb-2 rounded-3xl text-2xl">
                    {
                        selectedUserData["pages"]!=undefined?selectedUserData["pages"]["promos"]==true?"Allowed":"Not Allowed":""
                    }
                    </button>

                </div>



                        
            </div>:""
            }






        </div>
    )
}